import Avatar from '@orn/shared-web/components/Avatar';
import { cx } from '@orn/shared-web/utils/cx';
import { getInitial } from '@orn/shared-web/utils/person/getInitials';
import * as React from 'react';

import Entity from '../entity';

import type { EntityAvatarFragment } from '../entity/EntityAvatar/__generated__/EntityAvatar.gql';

interface IEntityNameAndAvatarProps {
  /** The merchant, or whatever stands in for one on this row (a card statement's account, say). */
  entity?: EntityAvatarFragment | null;
  /** Primary line when there's no `displayNameOverride` and no entity; also seeds the no-entity avatar initials. */
  fallbackDescription?: string;
  secondaryText?: React.ReactNode;
  displayNameClassName?: string;
  /** When set, replaces the entity name as the primary line; the avatar still derives from `entity`. */
  displayNameOverride?: string;
}

const EntityNameAndAvatar = ({
  entity,
  fallbackDescription,
  secondaryText,
  displayNameClassName,
  displayNameOverride,
}: IEntityNameAndAvatarProps) => {
  const displayName = displayNameOverride ?? entity?.name ?? fallbackDescription ?? '';

  const defaultAvatar = <Avatar contrastBorder={true} size="sm" shape="circle" initials={getInitial(displayName)} />;

  return (
    <div className="flex min-w-0 items-center gap-2">
      {entity ? <Entity.Avatar entity={entity} size="sm" /> : defaultAvatar}
      <div className="flex min-w-0 flex-1 flex-col">
        <span className={cx('text-primary truncate text-base font-medium', displayNameClassName)}>{displayName}</span>
        {secondaryText && <span className="text-tertiary text-sm font-medium">{secondaryText}</span>}
      </div>
    </div>
  );
};

export default EntityNameAndAvatar;
